import * as types from '../constants/actiontypes';

const initialState = {
	services: [],
};

const Services = (state = initialState, action) => {
	switch (action.type) {
		case types.RECEIVE_SERVICES:
			return { ...state, services: action.data };

		default:
			return state;
	}
};
export default Services;
